import { render, staticRenderFns } from "./notice_dialog.vue?vue&type=template&id=02c00e5b&scoped=true"
import script from "./notice_dialog.vue?vue&type=script&lang=js"
export * from "./notice_dialog.vue?vue&type=script&lang=js"
import style0 from "./notice_dialog.vue?vue&type=style&index=0&id=02c00e5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c00e5b",
  null
  
)

export default component.exports